import ApiService from '@/services/core/api.service'

const RawDataService = {
  async get (query) {
    return ApiService.get(`lead-supervisor/raw-data?${query}`)
  }
}

export default RawDataService
